<div class="custom-tooltip">
  <p>Exception Message:</p>
  <p>{{ exceptionMessage }}</p>
</div>